import { createAction, props } from '@ngrx/store';

export const deleteUserInfoStart = createAction('MITARBEITERVERWALTUNG::DELETE_USERINFO_START', props<{ item: number, userId: number }>());
export const deleteUserInfoSucceeded = createAction(
    'MITARBEITERVERWALTUNG::DELETE_USERINFO_SUCCEEDED'
);
export const deleteUserInfoFailed = createAction('MITARBEITERVERWALTUNG::DELETE_USERINFO_FAILED', props<{ error: string }>());
